import styled from "styled-components";

export const NavBarWrapper = styled.div`
  & > div {
    border-width: 1px;
  }
`;
